module.exports = __webpack_public_path__ + "img/assassin_2.b2a8bf0e.jpg";